import { displayName } from 'utils';

export const decorateBorrower = (borrower) => {
  if (borrower) {
    return { ...borrower, displayName: displayName(borrower.firstName, borrower.lastName) };
  }
  return undefined;
};
